import React from "react";
import { Doughnut } from "react-chartjs-2";

const DeliveryProgressBar = ({ progress }: any) => {
  const data = {
    datasets: [
      {
        data: [progress, 100 - progress],
        backgroundColor: ["#42A5F5", "#E0E0E0"],
        hoverBackgroundColor: ["#42A5F5", "#E0E0E0"],
        borderWidth: 0,
      },
    ],
  };

  const options = {
    cutoutPercentage: 70,
    rotation: -90,
    circumference: 360,
    tooltips: { enabled: false },
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      animateRotate: true,
      animateScale: true,
    },
  };

  return (
    <div style={{ width: 40, height: 40 }}>
      {" "}
      {/* Adjusted size for better visibility */}
      <Doughnut data={data} options={options} />
    </div>
  );
};

export default DeliveryProgressBar;
